import React from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { dateTemplate } from '../../appconfig/DatatableTemplateSetting';

const CustomDataTable = ({ refresher }: any) => {

    return (
        <>
            <div className="card up-title title">Upcoming Refresher Course</div>
            <DataTable value={refresher}  emptyMessage="No Refresher Course Found">
                <Column field="start_date" header={'Stard Date'} body={dateTemplate} style={{ width: '8rem' }}></Column>
                <Column field="end_date" header="End Date" body={dateTemplate} style={{ width: '8rem' }}></Column>
                <Column field="college.orgnameeng" header="College Name"></Column>
                <Column field="refresher_course_name" header="Course Name"></Column>
                <Column field="booked_slot" header="Booked Slots"></Column>
            </DataTable>
        </>
    );
};

export default CustomDataTable;
